var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagesAlertEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3D1F0B2C-393D-487B-9824-8A03202A9E59") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign_In_Email(X)-Copy",
    transform: "translate(-128, -477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0, 437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Images/alert_email",
    transform: "translate(128, 40)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.1,
    fill: "#256BFD",
    cx: 60,
    cy: 60,
    r: 60
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(34, 39)",
    stroke: "#256BFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7,36.75 L33.42846,21 M18.571436,21 L1.300078,36.75 M0,7.875 L21.22874,22.877925 C22.94786,24.0930375 23.80742,24.7004625 24.74238,24.9356625 C25.56814,25.1435625 26.43186,25.1435625 27.25762,24.9356625 C28.19258,24.7004625 29.05214,24.0930375 30.77126,22.877925 L52,7.875 M12.48,42 L39.52,42 C43.88852,42 46.07252,42 47.7412,41.141625 C49.2089,40.386675 50.40204,39.1820625 51.1498,37.70025 C52,36.015525 52,33.810525 52,29.4 L52,12.6 C52,8.18958 52,5.98437 51.1498,4.29982875 C50.40204,2.8180425 49.2089,1.613325 47.7412,0.8583225 C46.07252,0 43.88852,0 39.52,0 L12.48,0 C8.111584,0 5.927376,0 4.258878,0.8583225 C2.791204,1.613325 1.59796,2.8180425 0.850148,4.29982875 C0,5.98437 0,8.18958 0,12.6 L0,29.4 C0,33.810525 0,36.015525 0.850148,37.70025 C1.59796,39.1820625 2.791204,40.386675 4.258878,41.141625 C5.927376,42 8.111584,42 12.48,42 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesAlertEmail);
export default __webpack_public_path__ + "static/media/images_alert_email.08501b1de03710dae411488e8fbe71a2.svg";
export { ForwardRef as ReactComponent };